import React, { useState } from 'react';
import { MessageCircle, Send, Paperclip, Smile, MoreVertical, Phone, Video, Search, User, Clock } from 'lucide-react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

const Messagerie = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedConversation, setSelectedConversation] = useState(1);
    const [messageText, setMessageText] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const conversations = [
        {
            id: 1,
            contact: 'Cabinet CINEF-EC',
            avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
            lastMessage: 'Votre déclaration TVA a été traitée avec succès',
            timestamp: '14:30',
            unread: 2,
            status: 'online',
            type: 'cabinet'
        },
        {
            id: 2,
            contact: 'Expert-Comptable Principal',
            avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
            lastMessage: 'Les documents du bilan sont prêts',
            timestamp: '12:15',
            unread: 0,
            status: 'away',
            type: 'cabinet'
        },
        {
            id: 3,
            contact: 'Service Fiscal',
            avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
            lastMessage: 'Rappel: échéance CFE le 15 décembre',
            timestamp: 'Hier',
            unread: 1,
            status: 'offline',
            type: 'service'
        },
        {
            id: 4,
            contact: 'Assistant Comptable',
            avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
            lastMessage: 'Merci pour les factures envoyées',
            timestamp: 'Lun',
            unread: 0,
            status: 'online',
            type: 'cabinet'
        }
    ];

    const messages = {
        1: [
            {
                id: 1,
                sender: 'Cabinet CINEF-EC',
                content: 'Bonjour ! J\'ai bien reçu vos documents pour la déclaration TVA de juillet.',
                timestamp: '14:25',
                isOwn: false,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Vous',
                content: 'Parfait ! Avez-vous pu identifier des points particuliers ?',
                timestamp: '14:27',
                isOwn: true,
                type: 'text'
            },
            {
                id: 3,
                sender: 'Cabinet CINEF-EC',
                content: 'Tout est en ordre. La déclaration a été transmise avec succès. Vous devriez recevoir l\'accusé de réception sous 24h.',
                timestamp: '14:30',
                isOwn: false,
                type: 'text'
            },
            {
                id: 4,
                sender: 'Cabinet CINEF-EC',
                content: 'N\'hésitez pas si vous avez des questions concernant le prochain trimestre.',
                timestamp: '14:30',
                isOwn: false,
                type: 'text'
            }
        ],
        2: [
            {
                id: 1,
                sender: 'Expert-Comptable Principal',
                content: 'Bonjour, votre bilan semestriel est maintenant finalisé.',
                timestamp: '12:10',
                isOwn: false,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Expert-Comptable Principal',
                content: 'Les documents sont prêts pour signature. Souhaitez-vous un rendez-vous ?',
                timestamp: '12:15',
                isOwn: false,
                type: 'text'
            }
        ],
        3: [
            {
                id: 1,
                sender: 'Service Fiscal',
                content: 'Rappel important : échéance CFE le 15 décembre 2025',
                timestamp: 'Hier 16:45',
                isOwn: false,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Service Fiscal',
                content: 'Montant estimé : 850XOF. Pensez à effectuer le paiement avant la date limite.',
                timestamp: 'Hier 16:45',
                isOwn: false,
                type: 'text'
            }
        ],
        4: [
            {
                id: 1,
                sender: 'Vous',
                content: 'Voici les factures de juillet comme demandé.',
                timestamp: 'Lun 09:30',
                isOwn: true,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Assistant Comptable',
                content: 'Merci beaucoup ! Je vais les intégrer dans la comptabilité.',
                timestamp: 'Lun 10:15',
                isOwn: false,
                type: 'text'
            }
        ]
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'online':
                return '#10b981';
            case 'away':
                return '#f59e0b';
            case 'offline':
                return '#6b7280';
            default:
                return '#6b7280';
        }
    };

    const filteredConversations = conversations.filter(conv =>
        conv.contact.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSendMessage = () => {
        if (messageText.trim()) {
            // Logique d'envoi de message
            console.log('Message envoyé:', messageText);
            setMessageText('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <>
            <div className="app-container">
                <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

                <div className="main-wrapper">
                    <Navbar onMenuToggle={() => setIsSidebarOpen(!isSidebarOpen)} />

                    <main className="main-content">
                        {/* Header Section */}
                        <div className="page-header">
                            <div className="header-content">
                                <div className="header-text">
                                    <h1 className="page-title">Messagerie</h1>
                                    <p className="page-subtitle">Communiquez instantanément avec votre cabinet</p>
                                </div>
                            </div>
                        </div>

                        {/* Chat Container */}
                        <div className="chat-container">
                            {/* Sidebar des conversations */}
                            <div className="conversations-sidebar">
                                <div className="conversations-header">
                                    <div className="search-box">
                                        <Search size={20} className="search-icon" />
                                        <input
                                            type="text"
                                            placeholder="Rechercher une conversation..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="search-input"
                                        />
                                    </div>
                                </div>

                                <div className="conversations-list">
                                    {filteredConversations.map((conversation) => (
                                        <div
                                            key={conversation.id}
                                            className={`conversation-item ${selectedConversation === conversation.id ? 'active' : ''}`}
                                            onClick={() => setSelectedConversation(conversation.id)}
                                        >
                                            <div className="conversation-avatar">
                                                <img src={conversation.avatar} alt={conversation.contact} />
                                                <div
                                                    className="status-indicator"
                                                    style={{ backgroundColor: getStatusColor(conversation.status) }}
                                                ></div>
                                            </div>
                                            <div className="conversation-info">
                                                <div className="conversation-header">
                                                    <h4 className="conversation-name">{conversation.contact}</h4>
                                                    <span className="conversation-time">{conversation.timestamp}</span>
                                                </div>
                                                <div className="conversation-preview">
                                                    <p className="last-message">{conversation.lastMessage}</p>
                                                    {conversation.unread > 0 && (
                                                        <span className="unread-badge">{conversation.unread}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Zone de chat principale */}
                            <div className="chat-main">
                                {selectedConversation ? (
                                    <>
                                        {/* En-tête du chat */}
                                        <div className="chat-header">
                                            <div className="chat-contact-info">
                                                <img
                                                    src={conversations.find(c => c.id === selectedConversation)?.avatar}
                                                    alt="Contact"
                                                    className="chat-avatar"
                                                />
                                                <div className="chat-contact-details">
                                                    <h3 className="chat-contact-name">
                                                        {conversations.find(c => c.id === selectedConversation)?.contact}
                                                    </h3>
                                                    <p className="chat-contact-status">
                                                        {conversations.find(c => c.id === selectedConversation)?.status === 'online' ? 'En ligne' :
                                                         conversations.find(c => c.id === selectedConversation)?.status === 'away' ? 'Absent' : 'Hors ligne'}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="chat-actions">
                                                <button className="chat-action-btn">
                                                    <Phone size={20} />
                                                </button>
                                                <button className="chat-action-btn">
                                                    <Video size={20} />
                                                </button>
                                                <button className="chat-action-btn">
                                                    <MoreVertical size={20} />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Zone des messages */}
                                        <div className="messages-area">
                                            <div className="messages-list">
                                                {(messages[selectedConversation] || []).map((message) => (
                                                    <div
                                                        key={message.id}
                                                        className={`message ${message.isOwn ? 'own' : 'other'}`}
                                                    >
                                                        {!message.isOwn && (
                                                            <div className="message-avatar">
                                                                <User size={16} />
                                                            </div>
                                                        )}
                                                        <div className="message-content">
                                                            <div className="message-bubble">
                                                                <p className="message-text">{message.content}</p>
                                                            </div>
                                                            <div className="message-meta">
                                                                <span className="message-time">
                                                                    <Clock size={12} />
                                                                    {message.timestamp}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Zone de saisie */}
                                        <div className="message-input-area">
                                            <div className="message-input-container">
                                                <button className="attachment-btn">
                                                    <Paperclip size={20} />
                                                </button>
                                                <div className="input-wrapper">
                                                    <textarea
                                                        value={messageText}
                                                        onChange={(e) => setMessageText(e.target.value)}
                                                        onKeyPress={handleKeyPress}
                                                        placeholder="Tapez votre message..."
                                                        className="message-input"
                                                        rows="1"
                                                    />
                                                </div>
                                                <button className="emoji-btn">
                                                    <Smile size={20} />
                                                </button>
                                                <button
                                                    onClick={handleSendMessage}
                                                    className="send-btn"
                                                    disabled={!messageText.trim()}
                                                >
                                                    <Send size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="no-conversation">
                                        <MessageCircle size={64} className="no-conversation-icon" />
                                        <h3>Sélectionnez une conversation</h3>
                                        <p>Choisissez une conversation dans la liste pour commencer à échanger</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .app-container {
          display: flex;
          height: 100vh;
          background: linear-gradient(135deg, #f8fafb 0%, #f1f5f9 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .main-wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-left: 280px;
        }

        .main-content {
          flex: 1;
          padding: 32px;
          max-width: calc(100vw - 280px);
          box-sizing: border-box;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        /* Header Section */
        .page-header {
          margin-bottom: 24px;
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .header-icon {
          background: linear-gradient(135deg, #dc3545, #008A44);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          flex-shrink: 0;
        }

        .header-text {
          flex: 1;
        }

        .page-title {
          font-size: 32px;
          font-weight: 700;
          margin: 0 0 6px 0;
          background: linear-gradient(135deg, #dc3545, #008A44);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }

        .page-subtitle {
          color: #64748b;
          margin: 0;
          font-size: 16px;
          font-weight: 500;
        }

        /* Chat Container */
        .chat-container {
          flex: 1;
          display: flex;
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
          overflow: hidden;
          min-height: 0;
        }

        /* Conversations Sidebar */
        .conversations-sidebar {
          width: 380px;
          border-right: 1px solid #f1f5f9;
          display: flex;
          flex-direction: column;
          background: #fafbfc;
        }

        .conversations-header {
          padding: 20px;
          border-bottom: 1px solid #f1f5f9;
          background: #ffffff;
        }

        .search-box {
          position: relative;
        }

        .search-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: #9ca3af;
        }

        .search-input {
          width: 100%;
          padding: 12px 16px 12px 48px;
          border: 1px solid #d1d5db;
          border-radius: 12px;
          background: #ffffff;
          font-size: 14px;
          font-family: inherit;
          transition: all 0.2s ease;
        }

        .search-input:focus {
          outline: none;
          border-color: #10b981;
          box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
        }

        .conversations-list {
          flex: 1;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: rgba(0, 138, 68, 0.3) transparent;
        }

        .conversations-list::-webkit-scrollbar {
          width: 4px;
        }

        .conversations-list::-webkit-scrollbar-thumb {
          background: rgba(0, 138, 68, 0.2);
          border-radius: 10px;
        }

        .conversation-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 20px;
          cursor: pointer;
          transition: all 0.2s ease;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .conversation-item:hover {
          background: #ffffff;
        }

        .conversation-item.active {
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.08) 0%, rgba(0, 138, 68, 0.08) 100%);
          border-right: 3px solid #10b981;
        }

        .conversation-avatar {
          position: relative;
          flex-shrink: 0;
        }

        .conversation-avatar img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #ffffff;
        }

        .status-indicator {
          position: absolute;
          bottom: 2px;
          right: 2px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid #ffffff;
        }

        .conversation-info {
          flex: 1;
          min-width: 0;
        }

        .conversation-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
        }

        .conversation-name {
          font-size: 15px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .conversation-time {
          font-size: 12px;
          color: #64748b;
          font-weight: 500;
        }

        .conversation-preview {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .last-message {
          font-size: 13px;
          color: #64748b;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex: 1;
        }

        .unread-badge {
          background: linear-gradient(135deg, #dc3545, #b91c1c);
          color: #ffffff;
          font-size: 11px;
          font-weight: 700;
          padding: 2px 8px;
          border-radius: 12px;
          min-width: 18px;
          text-align: center;
          margin-left: 8px;
        }

        /* Chat Main Area */
        .chat-main {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-width: 0;
        }

        .chat-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #f1f5f9;
          background: #ffffff;
        }

        .chat-contact-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .chat-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }

        .chat-contact-details h3 {
          font-size: 16px;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 2px 0;
        }

        .chat-contact-status {
          font-size: 13px;
          color: #10b981;
          margin: 0;
          font-weight: 500;
        }

        .chat-actions {
          display: flex;
          gap: 8px;
        }

        .chat-action-btn {
          width: 40px;
          height: 40px;
          border: none;
          border-radius: 10px;
          background: #f8fafc;
          color: #64748b;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .chat-action-btn:hover {
          background: #10b981;
          color: #ffffff;
        }

        /* Messages Area */
        .messages-area {
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .messages-list {
          flex: 1;
          padding: 20px 24px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          gap: 16px;
          scrollbar-width: thin;
          scrollbar-color: rgba(0, 138, 68, 0.3) transparent;
        }

        .messages-list::-webkit-scrollbar {
          width: 4px;
        }

        .messages-list::-webkit-scrollbar-thumb {
          background: rgba(0, 138, 68, 0.2);
          border-radius: 10px;
        }

        .message {
          display: flex;
          gap: 12px;
          margin-bottom: 16px;
        }

        .message.own {
          flex-direction: row-reverse;
        }

        .message-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: linear-gradient(135deg, #dc3545, #008A44);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          flex-shrink: 0;
          align-self: flex-end;
        }

        .message-content {
          max-width: 70%;
        }

        .message-bubble {
          padding: 12px 16px;
          border-radius: 18px;
          margin-bottom: 4px;
        }

        .message.own .message-bubble {
          background: linear-gradient(135deg, #10b981, #059669);
          color: #ffffff;
          border-bottom-right-radius: 6px;
        }

        .message.other .message-bubble {
          background: #f8fafc;
          color: #1e293b;
          border: 1px solid #e2e8f0;
          border-bottom-left-radius: 6px;
        }

        .message-text {
          font-size: 14px;
          line-height: 1.5;
          margin: 0;
          word-wrap: break-word;
        }

        .message-meta {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 11px;
          color: #64748b;
          font-weight: 500;
        }

        .message.own .message-meta {
          justify-content: flex-end;
        }

        .message-time {
          display: flex;
          align-items: center;
          gap: 4px;
        }

        /* Message Input Area */
        .message-input-area {
          border-top: 1px solid #f1f5f9;
          background: #ffffff;
          padding: 20px 24px;
        }

        .message-input-container {
          display: flex;
          align-items: flex-end;
          gap: 12px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 20px;
          padding: 8px 16px;
        }

        .attachment-btn,
        .emoji-btn {
          width: 36px;
          height: 36px;
          border: none;
          background: transparent;
          color: #64748b;
          cursor: pointer;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .attachment-btn:hover,
        .emoji-btn:hover {
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
        }

        .input-wrapper {
          flex: 1;
          min-height: 36px;
          display: flex;
          align-items: center;
        }

        .message-input {
          width: 100%;
          border: none;
          background: transparent;
          resize: none;
          font-size: 14px;
          font-family: inherit;
          line-height: 1.5;
          padding: 8px 0;
          max-height: 120px;
          min-height: 20px;
        }

        .message-input:focus {
          outline: none;
        }

        .message-input::placeholder {
          color: #9ca3af;
        }

        .send-btn {
          width: 36px;
          height: 36px;
          border: none;
          background: linear-gradient(135deg, #10b981, #059669);
          color: #ffffff;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .send-btn:hover:not(:disabled) {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }

        .send-btn:disabled {
          background: #d1d5db;
          cursor: not-allowed;
        }

        /* No Conversation State */
        .no-conversation {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #64748b;
          padding: 40px;
        }

        .no-conversation-icon {
          color: #d1d5db;
          margin-bottom: 24px;
        }

        .no-conversation h3 {
          font-size: 20px;
          font-weight: 600;
          color: #374151;
          margin: 0 0 8px 0;
        }

        .no-conversation p {
          font-size: 14px;
          margin: 0;
        }

        /* Responsive Design */
        @media (max-width: 1023px) {
          .main-wrapper {
            margin-left: 0;
          }

          .main-content {
            padding: 20px;
          }

          .conversations-sidebar {
            width: 320px;
          }
        }

        @media (max-width: 768px) {
          .main-content {
            padding: 16px;
          }

          .header-content {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }

          .page-title {
            font-size: 24px;
          }

          .chat-container {
            flex-direction: column;
            height: calc(100vh - 200px);
          }

          .conversations-sidebar {
            width: 100%;
            height: 300px;
            border-right: none;
            border-bottom: 1px solid #f1f5f9;
          }

          .chat-main {
            flex: 1;
          }

          .message-content {
            max-width: 85%;
          }
        }

        @media (max-width: 480px) {
          .conversations-sidebar {
            height: 250px;
          }

          .conversation-item {
            padding: 12px 16px;
          }

          .conversation-avatar img {
            width: 40px;
            height: 40px;
          }

          .message-input-container {
            padding: 6px 12px;
          }

          .chat-header {
            padding: 16px 20px;
          }

          .messages-list {
            padding: 16px 20px;
          }

          .message-input-area {
            padding: 16px 20px;
          }
        }
      `}</style>
        </>
    );
};

export default Messagerie;